/* ═══════════════════════════════════════════════════
   DWL — uitklapbare zoekbalk op mobiel

   WAAROM EIGEN MARKUP
   De zoekbalk van het théma heeft eigen open/dicht-logica en classes die
   op een telefoon soms wél en soms niet gezet werden — met een veld van
   nul pixels breed als resultaat. Deze balk is van onszelf.

   ⚠ DE BALK WORDT DIRECT BIJ HET LADEN GEBOUWD, niet pas bij de eerste
   klik. Reden: dwl-suggest.js zoekt alleen in de eerste seconden na het
   laden naar velden met name="q". Bouwden we de balk pas bij de eerste
   klik, dan bestond dat veld op dat moment niet en bleven de suggesties
   leeg — pas na sluiten en opnieuw openen verschenen ze.

   SLUITEN — DRIE WEGEN, want alleen "ergens wegklikken" is te vaag:
     1. De loep verandert in een kruisje zolang de balk openstaat.
        Dezelfde knop, twee standen: zo zie je dát je hem kunt sluiten.
     2. Escape (toetsenbord).
     3. Tikken buiten de balk.
   ════════════════════════════════════════════════════ */
(function () {

  var PLACEHOLDER = 'Search ducks…';

  /* Kruisje dat de loep vervangt zolang de balk openstaat. */
  var CLOSE_ICON =
    '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" ' +
    'stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
    '<line x1="6" y1="6" x2="18" y2="18"></line>' +
    '<line x1="18" y1="6" x2="6" y2="18"></line></svg>';

  function isTouch() {
    return window.matchMedia('(hover: none)').matches;
  }

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (r || '/').replace(/\/$/, '');
  }

  var bar = null;
  var icons = [];   /* de loep-elementen in de header */

  function build() {
    if (bar) return bar;

    bar = document.createElement('div');
    bar.className = 'dwl-searchbar';
    bar.hidden = true;
    bar.innerHTML =
      '<form class="dwl-searchbar__form" action="' + root() + '/search" method="get" role="search">' +
        '<input type="hidden" name="type" value="product,page,article">' +
        '<input type="hidden" name="options[prefix]" value="last">' +
        '<span class="dwl-searchbar__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" ' +
          'stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle>' +
          '<line x1="16.5" y1="16.5" x2="21" y2="21"></line></svg>' +
        '</span>' +
        '<input class="dwl-searchbar__input" type="search" name="q" ' +
          'placeholder="' + PLACEHOLDER + '" autocomplete="off" ' +
          'autocorrect="off" autocapitalize="off" spellcheck="false">' +
        '<button type="button" class="dwl-searchbar__close" aria-label="Clear search">' +
          '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" ' +
          'stroke-width="2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line>' +
          '<line x1="18" y1="6" x2="6" y2="18"></line></svg>' +
        '</button>' +
        '<button type="submit" class="dwl-searchbar__submit" aria-label="Search">' +
          '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" ' +
          'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
          '<line x1="4" y1="12" x2="19" y2="12"></line>' +
          '<polyline points="13,6 19,12 13,18"></polyline></svg>' +
        '</button>' +
      '</form>';

    document.body.appendChild(bar);

    var form = bar.querySelector('.dwl-searchbar__form');
    var field = bar.querySelector('.dwl-searchbar__input');

    /* De wisknop verschijnt alleen als er tekst staat. */
    function syncClear() {
      if (field.value) {
        form.classList.add('has-text');
      } else {
        form.classList.remove('has-text');
      }
    }

    field.addEventListener('input', syncClear);

    bar.querySelector('.dwl-searchbar__close').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      field.value = '';
      field.dispatchEvent(new Event('input', { bubbles: true }));
      syncClear();
      field.focus();
    });

    /* Leeg formulier niet verzenden — dat levert een lege zoekpagina op. */
    form.addEventListener('submit', function (e) {
      if (!field.value.trim()) {
        e.preventDefault();
        field.focus();
      }
    });

    field.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) close();
    });

    document.addEventListener('click', function (e) {
      if (!bar || bar.hidden) return;
      if (bar.contains(e.target)) return;
      if (e.target.closest && e.target.closest('.dwl-suggest')) return;
      if (e.target.closest && e.target.closest('.search-dropdown')) return;
      close();
    }, true);

    return bar;
  }

  /* Loep ↔ kruisje. De originele inhoud bewaren we op het element zelf,
     zodat we bij sluiten exact terugzetten wat het thema er had staan. */
  function setIconState(open) {
    for (var i = 0; i < icons.length; i++) {
      var icon = icons[i];
      if (open) {
        if (!icon.dataset.dwlOriginal) {
          icon.dataset.dwlOriginal = icon.innerHTML;
        }
        icon.innerHTML = CLOSE_ICON;
        icon.classList.add('dwl-icon-close');
        icon.setAttribute('aria-label', 'Close search');
      } else if (icon.dataset.dwlOriginal) {
        icon.innerHTML = icon.dataset.dwlOriginal;
        icon.classList.remove('dwl-icon-close');
        icon.setAttribute('aria-label', 'Search');
      }
    }
  }

  /* De onderkant van de header verschuift zodra de lopende tekstbalk
     wegscrolt; daarom meten in plaats van een vast getal. */
  function position() {
    var header = document.querySelector('.shopify-header-section');
    var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 96;
    if (bar) bar.style.top = top + 'px';
  }

  function open() {
    build();
    position();
    bar.hidden = false;
    document.documentElement.classList.add('dwl-searchbar-open');
    setIconState(true);
    var field = bar.querySelector('.dwl-searchbar__input');
    /* Kleine vertraging: iOS opent het toetsenbord alleen betrouwbaar
       als het veld al zichtbaar is. */
    setTimeout(function () { field.focus(); }, 60);
  }

  function close() {
    if (!bar) return;
    var form = bar.querySelector('.dwl-searchbar__form');
    var field = bar.querySelector('.dwl-searchbar__input');
    field.value = '';
    field.dispatchEvent(new Event('input', { bubbles: true }));
    form.classList.remove('has-text');
    field.blur();
    bar.hidden = true;
    document.documentElement.classList.remove('dwl-searchbar-open');
    setIconState(false);
    var panel = bar.querySelector('.dwl-suggest');
    if (panel) { panel.hidden = true; panel.innerHTML = ''; }
  }

  function toggle() {
    if (bar && !bar.hidden) { close(); return; }
    open();
  }

  /* De loep opent de balk in plaats van de dropdown van het thema.
     Capture + stopImmediatePropagation, zodat de listener uit
     header.liquid niet alsnog zijn eigen paneel opent. */
  function wireIcon(rootEl) {
    var icon = rootEl.querySelector('.search-dropdown-form-label-icon');
    if (!icon || icon.dataset.dwlBar === '1') return;
    icon.dataset.dwlBar = '1';
    icons.push(icon);

    icon.addEventListener('click', function (e) {
      if (!isTouch()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      toggle();
    }, true);

    icon.style.cursor = 'pointer';
  }

  function scan() {
    var roots = document.querySelectorAll('.section-header-right .search-dropdown');
    for (var i = 0; i < roots.length; i++) wireIcon(roots[i]);
  }

  function boot() {
    /* Meteen bouwen — zie de waarschuwing bovenaan. */
    build();
    scan();

    window.addEventListener('scroll', function () { if (bar && !bar.hidden) position(); }, { passive: true });
    window.addEventListener('resize', function () { if (bar && !bar.hidden) position(); });
    window.addEventListener('orientationchange', function () { if (bar && !bar.hidden) position(); });

    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      scan();
      if (tries > 20) clearInterval(iv);
    }, 250);
    document.addEventListener('shopify:section:load', scan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
